module.exports = __webpack_public_path__ + "static/media/pin-outlined-blue.bd2cc326.svg";